module.exports = __webpack_public_path__ + "static/media/phone.813984b8.png";